import { render } from "./nav-bar.vue?vue&type=template&id=bc1d798c"
import script from "./nav-bar.vue?vue&type=script&lang=js"
export * from "./nav-bar.vue?vue&type=script&lang=js"

import exportComponent from "C:\\Project\\CT\\Crm-Xmarks\\crm-waha\\crm-frontend\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__